<template>
  <div>
    <el-dialog
      title="富文本配置"
      width="50%"
      top="2%"
      :visible.sync="dialogVisible"
      @close="handleClose"
      :close-on-click-modal="false"
    >
      <!-- <el-button type="warning" size="medium" @click="openAddImg"
        >图片上传</el-button
      > -->
      <el-button type="success" size="medium" @click="openLook"
        >预览页面</el-button
      >
      <el-button type="danger" size="medium" @click="handleCope"
        >复制图文</el-button
      >
      <el-button type="primary" size="medium" @click="handleSubmit"
        >保存</el-button
      >
      <br /><br />
      <div ref="content" id="wangEditor" class="wangEditor"></div>
    </el-dialog>
    <el-dialog
      title="上传图片"
      :visible.sync="dialogVisibleAddImg"
      width="800px"
      @close="handleAddImgClose"
      :close-on-click-modal="false"
      style="height:500px"
    >
      <el-form ref="form" :model="editParam" label-width="300px">
        <div class="form-flex-box">
          <el-form-item label="" prop="cover">
            <el-upload
              class="upload-demo"
              name="upload"
              accept="image/jpeg, image/png, image/jpg, image/gif, image/webp"
              :action="action"
              :headers="header"
              :on-success="imageUploadSuccess"
              :on-error="imageUploadFail"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
            <decrypt-img
              v-if="editParam.cover"
              style="height: 100px"
              :src="setImage(editParam.cover)"
              :preview-src-list="[setImage(editParam.cover)]"
            >
            </decrypt-img>
          </el-form-item>
        </div>
        图片地址:
        <span>{{ editParam.cover ? setImage(editParam.cover) : null }}</span>
      </el-form>
    </el-dialog>

    <rich-preview ref="preview"></rich-preview>
  </div>
</template>

<script>
// 引入 wangEditor
import wangEditor from "wangeditor";
import RichPreview from "@/components/rich-preview/index.vue";
import API from "@/api";
import baseConfig from "@/utils/serverUrlConfig";
import local from "@/utils/localStroage";
import { isFullURL } from "../../utils/validator";
import { decryptTool } from "../decrypt-img/tool";

const observedElements = [];
let observer = null;

export default {
  components: { RichPreview },
  data() {
    return {
      dialogVisible: false,
      dialogVisibleLook: false,
      dialogVisibleAddImg: false,
      editor: null,
      editorData: "",
      id: "",
      richText: "",
      cope_rich_text: "",
      data: "",
      video: null, //视频对象
      // 封面上传地址
      action: baseConfig.baseServerUrl + "/vid/uploadStatic",
      header: {
        Authorization: local.get("userInfo").token,
      },
      editParam: {
        imgUrl: baseConfig.imgUrl,
        cover: "",
      },
      copySrc: "",
    };
  },
  created() {
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.observeEntry(entry);
        });
      },
      { threshold: 0.1 }
    );
  },
  mounted() {
    // 监听 copy 事件
    document.addEventListener("copy", this.handleCopy);
  },
  beforeDestroy() {
    this.unobserveImages();
    observer.disconnect();
    // 移除事件监听
    document.removeEventListener("copy", this.handleCopy);
  },
  methods: {
    handleCopy(event) {
      const newHtml = event.target.outerHTML;
      const parser = new DOMParser();
      const doc = parser.parseFromString(newHtml, "text/html");
      if (
        doc.getElementsByTagName("img") &&
        doc.getElementsByTagName("img").length
      ) {
        this.copySrc = doc.getElementsByTagName("img")[0].getAttribute("title");
      } else {
        this.copySrc = "";
      }
    },
    createEditor() {
      const editor = new wangEditor(`#wangEditor`);
      editor.config.uploadImgServer = this.action;
      editor.config.uploadImgHeaders = this.header;
      editor.config.uploadFileName = "upload";
      editor.config.pasteFilterStyle = false;
      editor.config.pasteIgnoreImg = false;
      editor.config.customAlert = () => {};
      editor.config.uploadImgHooks = {
        customInsert: async (insertImgFn, result) => {
          if (result.code === 200) {
            // insertImgFn 可把图片插入到编辑器，传入图片 src ，执行函数即可
            insertImgFn(result.data.coverImg, "");
            this.handleDynamicElements();
          }
        },
      };
      editor.config.height = 700;
      // 配置 onchange 回调函数，将数据同步到 vue 中
      editor.config.onchange = (newHtml) => {
        this.editorData = newHtml;
      };
      // 粘贴的钩子
      editor.config.pasteTextHandle = (newHtml) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(newHtml, "text/html");
        const images = doc.getElementsByTagName("img");
        if (images && images.length) {
          let src = images[0].getAttribute("src");
          let originSrc = images[0].getAttribute("title");
          setTimeout(() => {
            this.processImages(src, originSrc);
          }, 500);
        }
        return newHtml;
      };
      // 创建编辑器
      editor.create();
      if (this.richText != "" && this.richText != "") {
        editor.txt.html(this.richText);
      }
      this.editor = editor;
      this.handleDynamicElements();
    },
    processImages(src) {
      const images = this.$refs.content.querySelectorAll("img[src]");
      images.forEach((img) => {
        if (img.getAttribute("src") == src) {
          img.setAttribute("origin-src", this.copySrc);
        }
      });
    },
    // **** 图片解密处理图片 start！！！
    async handleDynamicElements() {
      await this.$nextTick();
      const imgs = this.$refs.content.getElementsByTagName("img");
      this.observeImages(imgs);
    },
    observeImages(imgs) {
      // 先移除原来的监听
      this.unobserveImages();
      if (!imgs) return;
      for (let index = 0; index < imgs.length; index++) {
        const element = imgs[index];
        if (element.getAttribute("origin-src")) continue;
        element.setAttribute("alt", "");
        observer.observe(element);
        observedElements.push(element);
      }
    },
    async observeEntry(entry) {
      const { intersectionRatio } = entry;
      if (intersectionRatio <= 0) return;
      const target = entry.target;
      const tempSrc = target.getAttribute("src");
      if (!tempSrc) {
        // 没有临时路径，清除监听
        this.unobserveEntry(entry);
        return;
      }
      // 是完整url，无需解密直接src加载
      if (isFullURL(tempSrc)) {
        target.style.minHeight = target.style.minHeight || "auto";
        target.setAttribute("src", tempSrc);
        target.setAttribute("origin-src", tempSrc);
        target.setAttribute("title", tempSrc);
        this.unobserveEntry(entry);
        return;
      }
      try {
        let imgApi = this.$imgUrl;
        if (imgApi.slice(-1) != "/") {
          imgApi = imgApi + "/";
        }
        const url = await decryptTool.imgDecypt(imgApi + tempSrc);
        target.style.minHeight = target.style.minHeight || "auto";
        target.setAttribute("src", url);
        target.setAttribute("origin-src", tempSrc);
        target.setAttribute("title", tempSrc);
        this.unobserveEntry(entry);
      } catch (error) {
        console.error("img decypt error:", error);
      }
    },
    unobserveImages() {
      observedElements.forEach((v) => observer.unobserve(v));
      observedElements.splice(0);
    },
    unobserveImage(img) {
      observer.unobserve(img);
      const idx = observedElements.indexOf(img);
      if (idx >= 0) {
        observedElements.splice(idx, 1);
      }
    },
    unobserveEntry(entry) {
      this.unobserveImage(entry.target);
    },
    // **** 图片解密处理图片 end！！！
    // 打开编辑视频弹窗、传递需要编辑的参数
    async open(video) {
      this.dialogVisible = true;
      this.video = video;
      this.id = video.id;
      if (video.richText && video.richText != "") {
        this.richText = video.richText;
        // this.richText = video.richText.replace(
        //   /<img src="/g,
        //   `<img src="${ resourceHost }`
        // );
      }
      //处理复制图文业务
      var cope_rich_text = "<p>";
      if (video.title !== "") {
        cope_rich_text += video.title;
        cope_rich_text += "<br/><br/>";
      }
      if (video.content !== "") {
        cope_rich_text += video.content;
      }
      if (video.seriesCover !== "") {
        var seriesCover = video.seriesCover || [];
        if (seriesCover.length > 0);
        for (const p of seriesCover) {
          cope_rich_text += `<br/><br/><img src="`;
          cope_rich_text += p;
          cope_rich_text += '"/><br/><br/>';
        }
      }
      if (cope_rich_text !== "<p>") {
        this.cope_rich_text = cope_rich_text;
      }
      await this.$nextTick();
      this.createEditor();
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.editor && this.editor.destroy();
      this.editor = null;
      this.cleanData();
    },
    handleAddImgClose() {
      this.dialogVisibleAddImg = false;
      this.data = "";
      this.editParam = {
        imgUrl: baseConfig.imgUrl,
        cover: "",
      };
    },
    openAddImg() {
      this.dialogVisibleAddImg = true;
    },
    cleanData() {
      this.id = "";
      this.richText = "";
      this.cope_rich_text = "";
      this.video = null;
    },
    openLook() {
      this.dialogVisibleLook = true;
      this.data = this.editor.txt.html();
      this.$refs.preview.open(this.richText, false);
    },
    handleSubmit() {
      this.data = this.editor.txt.html();
      if (!this.data) {
        alert("保存内容为空");
        return;
      }
      const parser = new DOMParser();
      const doc = parser.parseFromString(this.data, "text/html");
      const images = doc.getElementsByTagName("img");
      for (const img of Array.from(images)) {
        const src = img.getAttribute("origin-src");
        if (src) {
          img.setAttribute("src", src);
          img.removeAttribute("origin-src");
        }
        img.setAttribute("alt", "");
      }
      this.data = doc.body.innerHTML;
      this.submitDate();
    },
    async handleCope() {
      this.richText = this.cope_rich_text;
      this.editor.destroy();
      this.editor = null;
      this.$nextTick();
      this.createEditor();
    },
    // 保存
    submitDate() {
      if (this.data == null || this.data == "") {
        alert("保存内容为空");
        return;
      }
      if (this.video == null || this.video == "") {
        alert("保存内容异常");
        return;
      }
      if (this.id == null || this.id == "") {
        alert("编辑帖子id异常！");
        return;
      }
      //编辑
      const params = {};
      params.id = this.id;
      params.richText = this.data;
      // params.type = 2;
      API.editVideoInfo(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "保存成功！",
              type: "success",
            });
            this.$emit("handlerLoadList");
          } else {
            this.$message.error(res.msg || res.tip || "保存失败！");
          }
          this.handleClose();
        })
        .catch((e) => {
          console.error(e);
        });
    },
    async updateFile(file) {
      const form = new FormData();
      form.append("upload", file.file);
      const { data } = await API.fileUpload(form);
      this.editParam.cover = data.coverImg;
    },
    imageUploadSuccess(res) {
      if (res.code === 200) {
        this.editParam.cover = res.data.coverImg;
      } else {
        this.$message.error(res.data);
      }
    },
    imageUploadFail(res) {
      this.$message.error(res.message);
    },
    setImage(val) {
      return this.editParam.imgUrl + val;
    },
  },
};
</script>

<style lang="scss" scoped>
.wangEditor {
  /deep/ img {
    // width: 100%;
    min-height: 200px;
  }
}
</style>
